export enum AdminOrganizationApiErrorTypes {
  AdminLoadOrganizationsError,
  AdminLoadOrganizationsCsvError,
  AdminLoadOrganizationError,
  AdminOrganizationNotFoundError,
  AdminCreateOrganizationError,
  AdminDeleteOrganizationError,
  AdminHardDeleteOrganizationError,
  AdminUpdateOrganizationError,
  AdminConflictOrganizationError,
  AdminUndeployAllProjectsInOrganizationError,
}

export class AdminOrganizationApiError {
  constructor(public type: AdminOrganizationApiErrorTypes, public error: Error) {}
}
